<template>
  <div class="page-container">
    <el-breadcrumb separator="/" class="page-breadcrumb">
      <el-breadcrumb-item>
        API 请求日志
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never" class="page-content">
      <div class="page-actions">
        <el-input placeholder="请输入用户ID" v-model="query"></el-input>
        <el-button type="primary" @click="handleSearch({ page: 1 })"
          >查询</el-button
        >
      </div>
      <el-table :data="logList">
        <el-table-column label="请求时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | moment }}
          </template>
        </el-table-column>
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="请求URL" prop="url"></el-table-column>
        <el-table-column label="请求参数" prop="args"></el-table-column>
        <el-table-column label="IP" prop="ip"></el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'ApiRequestLog',
  data() {
    return {
      query: ''
    };
  },
  components: {
    Pagination
  },
  computed: {
    ...mapState('apiLog', ['pagination', 'logList', 'totalCount'])
  },
  methods: {
    ...mapActions('apiLog', ['list']),
    handleSearch(data = {}) {
      this.list({
        ...this.pagination,
        ...data,
        userId: this.query
      });
    },
    pageChanged(pagination) {
      this.list({
        ...this.pagination,
        ...pagination,
        userId: this.query
      });
    }
  },
  mounted() {
    this.list({
      ...this.pagination
    });
  }
};
</script>

<style lang="less" scoped></style>
